<template>
  <div class="history_card">
    <div class="history_card_header">
      <CountryFlags :country="history.country"/>
      <span class="setting-card_header_name">{{ history.place }}</span>
      <span class="mdi mdi-close" @click="hide_info"></span>
    </div>

    <div class="history_card_content">

      <div class="l_block">
        <div class="line period">
          <span class="left">
            {{ translate("location.period") }}:
          </span>
          <span class="right">
            {{ history.period[0] }} - {{ history.period[1] }}
          </span>
        </div>

        <div class="line duration">
          <span class="left">
            {{ translate("location.duration") }}:
          </span>
          <span class="right">
            {{ uptimeToStr(history.duration) }}
          </span>
        </div>

        <div class="line online">
          <span class="left">
            Online:
          </span>
          <span class="right">
            {{ uptimeToStr(history.online_stats.online) }}
          </span>
        </div>

        <div class="line online">
          <span class="left">
            Count:
          </span>
          <span class="right">
            {{ history.online_stats.online_interval_count }}
          </span>
        </div>
      </div>

      <div class="r_block">
        <div class="links">
          <router-link class="stats" :to="'/device/' + $route.params.device_id + '/stats?&simcard_status=true&ts_start='+get_timestamp(history.period[0])+'&ts_end='+get_timestamp(history.period[1])">
            {{ translate("device.section.stats") }}
          </router-link>
          <router-link class="tracking" :to="'/device/' + $route.params.device_id + '/tracking?&ts_start='+get_timestamp(history.period[0])+'&ts_end='+get_timestamp(history.period[1])">
            {{ translate("device.section.tracking") }}
          </router-link>
        </div>

        <div class="graph_wrap">
          <p class="top">{{ translate("custom.online") }}</p>
          <div class="content">
            <span class="value">{{ history.online_stats.online_percent }}%</span>
            <span class="graph" :style="style_percent(history.online_stats.online_percent)"/></div>
        </div>
      </div>
    </div>
    <div class="history_card_footer" v-if="history.simcard_traffic_stats.length > 0">
      <div class="response_table">
        <table>
          <thead>
          <tr>
            <th scope="col" class="pointer" @click="change_filter('operator')"
                :class="{'selected' : filter_type === 'operator'}">
              Operator
              <i class="mdi mdi-arrow-down"
                 :class="{'reverse' : filter_asc === 'asc' && filter_type === 'operator'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('imsi')"
                :class="{'selected' : filter_type === 'imsi'}">
              IMSI
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'imsi'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('rx')" :class="{'selected' : filter_type === 'rx'}">
              RX
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'rx'}"></i>
            </th>
            <th scope="col" class="pointer" @click="change_filter('tx')" :class="{'selected' : filter_type === 'tx'}">
              TX
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'tx'}"></i>
            </th>
          </tr>
          </thead>

          <tbody>
          <tr
              v-for="(value, key) in traffic_stats"
              :key="key"
          >
            <td data-label="operator">
              {{ value.operator }}
            </td>
            <td data-label="IMSI">
              {{ value.imsi }}
            </td>
            <td data-label="RX">
              {{ value.rx }}
            </td>
            <td data-label="TX">
              {{ value.tx }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>

import CountryFlags from "components/UIComponents/CountryFlags/CountryFlags.vue";

export default {
    name: 'LocationDetails',
    components: {
      CountryFlags
    },
    props: ['history'],

    data () {
      return {
        filter_type: 'operator',
        filter_asc: 'asc',
      }
    },
    created () {

    },
    computed:{
      traffic_stats(){
        let list = [...this.history.simcard_traffic_stats]
        list.sort(this.compareNumbers)
        return list
      }
    },
    methods:{
      get_timestamp(period){
        let dt = period.split(" ")
        let dates = dt[0].split("-")
        let times = dt[1].split("-")
        let new_date = new Date().setFullYear("20" + dates[0], dates[1] - 1, dates[2])
        new_date = new Date(new_date).setHours(times[0], times[1], 0, 0)
        return new_date / 1000
      },
      hide_info(){
        this.$emit("hide_info", this.history.id)
      },
      uptimeToStr(timeUp) {
        let str = "";

        let days = Math.floor(timeUp / 86400);

        if (days) {
          days = days < 10 ? ("0" + days).slice(-2) : days;
          str += days > 0 ? days + " " + this.translate("date.d") + " " : "";
        }

        let hours = Math.floor((timeUp % 86400) / 3600);
        if (hours) {
          str += ("0" + hours).slice(-2) + " " + this.translate("date.h") + " ";
        }

        if (!days || hours === 0) {
          let min = Math.floor((timeUp % 3600) / 60);
          str += ("0" + min).slice(-2) + " " + this.translate("date.min") + " ";
        }

        if (!days && !hours) {
          let sec = Math.floor(timeUp % 60);
          str += ("0" + sec).slice(-2) + " " + this.translate("date.sec") + " ";
        }

        return str;
      },
      style_percent(percent){
        let color = ''

        if (percent <= 80){
          color = '#FF0000'
        }else if(percent >= 95){
          color = '#01AA88'
        }else{
          color = '#FFA200'
        }

        return '--p:' + percent + ';' + ';--c:' + color + ';--b:3px;--lw:' + percent + '%'
      },
    }
}

</script>
<style lang="scss" scoped>

.history_card {
  border-radius: 10px;
  box-shadow: 0 2px 2px #ccc5b980;
  color: #252422;
  padding-bottom: 10px;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  margin-bottom: 15px;
  overflow: hidden;
  &_header {
    font: 300 14px/20px "Roboto", Arial, sans-serif;
    text-transform: uppercase;
    position: relative;
    color: #000;
    background: #f4f3ef;
    padding: 1rem 2rem;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .phoca-flag{
      position: relative;
      width: 30px;
      height: 20px;
      margin: 0;
      box-shadow: none;
      border: none;
    }
    .mdi-close{
      //position: absolute;
      font-size: 16px;
      top: 10px;
      right: 15px;
    }
  }
  &_content {
    font: 300 12px/16px "Roboto", Arial, sans-serif;
    text-align: center;
    padding: 10px;
    display: flex;
    align-content: flex-start;
    justify-content: center;

    .r_block{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 5px 10px;
    }

    .l_block, .r_block{
      width: 50%;

      .links{
        display: flex;
        justify-content: space-around;
        .stats, .tracking{
          font-size: 14px;
        }
      }

      .graph{
        &_wrap{

          width: 100%;
          .wrap{
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
          }
          .top{
            width: 100%;
            text-align: center;
            margin-bottom: 0;
          }
          .content{
            width: 100%;
            display: flex;
            align-items: center;
            .value{
              width: 60px;
              margin-right: 10px;
            }
          }

        }
        display: block;
        position: relative;
        width: calc(100% - 37px);
        background: #D5E7FF;
        height: 10px;
        border-radius: 2px;
        overflow-x: hidden;
        &::after{
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: var(--lw);
          height: 10px;
          background: var(--c);
          border-radius: 2px 0 0 2px;
        }
      }

      .line{
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        &:nth-child(2n+1) {
          background-color: #e2ecdc;
        }
        span{
          text-align: left;
        }
        .left{
          width: 40%;
        }
        .right{
          width: 60%;
          p{
            font-size: 12px;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  &_footer{
    padding: 0 10px;
    .response_table{
      padding: 0;
    }
  }
}


</style>
